export default ['JsonRPCService', function (JsonRPCService) {
    return {
        makeDirectPayment: function makeDirectPayment(accountNumber, invoiceIds, amount, instrument) {
            /** Trim a payment amount. */
            var roundedAmount = Math.round(amount * 100) / 100;

            var request = {
                invoiceIds: invoiceIds,
                amountPaid: roundedAmount,
                paymentInstrument: instrument
            };

            var process = JsonRPCService.send('bc', 'gatewaybilling/directBillPayment', 'makeDirectBillPayment', [accountNumber, request], []);
            return process.then(function () {
                return {
                    state: 'gateway-billing-make-payment-confirmation',
                    stateParams: {
                        accountNumber: accountNumber
                    }
                };
            });
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/integration/billing/bc3/services/GatewayPaymentMethodService.js
// module id = 2202
// module chunks = 0